import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { API_S3_BASE_URL } from '../../apiConstant';

export const useS3FilesByType = ({ type, id, clientId }) => {
  return useQuery({
    queryKey: ['s3-files', type, id, clientId],
    enabled: !!type && !!id,
    retry: false,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    placeholderData: [],
    queryFn: async () => {
      try {
        const res = await axios.get(`${API_S3_BASE_URL}/api/s3/by-type`, {
          params: { type, id, clientId },
        });
        return res.data || [];
      } catch (error) {
        console.warn('useS3FilesByType: Failed to fetch files', error?.message);
        return [];
      }
    },
  });
};
